export const ACTOR_TYPES = [
  "character",
  "npc",
  "creature"
];

/* -------------------------------------------- */

export const PROPERTIES = [
  "activeEffect.deleted",
  "activeEffect.disabled",
  "actor.inCombat",
  "actor.itemCreated",
  "actor.itemDeleted",
  "actor.name",
  "actor.system.attribs.armor.value",
  "actor.system.attribs.build.current",
  "actor.system.attribs.build.value",
  "actor.system.attribs.db.value",
  "actor.system.attribs.hp.max",
  "actor.system.attribs.hp.value",
  "actor.system.attribs.lck.bonusDice",
  "actor.system.attribs.lck.value",
  "actor.system.attribs.mov.type",
  "actor.system.attribs.mov.value",
  "actor.system.attribs.mp.max",
  "actor.system.attribs.mp.value",
  "actor.system.attribs.san.bonusDice",
  "actor.system.attribs.san.dailyLoss",
  "actor.system.attribs.san.max",
  "actor.system.attribs.san.value",
  "actor.system.characteristics.app.bonusDice",
  "actor.system.characteristics.app.tempValue",
  "actor.system.characteristics.app.value",
  "actor.system.characteristics.con.bonusDice",
  "actor.system.characteristics.con.tempValue",
  "actor.system.characteristics.con.value",
  "actor.system.characteristics.dex.bonusDice",
  "actor.system.characteristics.dex.tempValue",
  "actor.system.characteristics.dex.value",
  "actor.system.characteristics.edu.bonusDice",
  "actor.system.characteristics.edu.tempValue",
  "actor.system.characteristics.edu.value",
  "actor.system.characteristics.int.bonusDice",
  "actor.system.characteristics.int.tempValue",
  "actor.system.characteristics.int.value",
  "actor.system.characteristics.pow.bonusDice",
  "actor.system.characteristics.pow.tempValue",
  "actor.system.characteristics.pow.value",
  "actor.system.characteristics.siz.bonusDice",
  "actor.system.characteristics.siz.tempValue",
  "actor.system.characteristics.siz.value",
  "actor.system.characteristics.str.bonusDice",
  "actor.system.characteristics.str.tempValue",
  "actor.system.characteristics.str.value",
  "actor.system.conditions.criticalWounds.value",
  "actor.system.conditions.dead.value",
  "actor.system.conditions.dying.value",
  "actor.system.conditions.indefInsane.value",
  "actor.system.conditions.prone.value",
  "actor.system.conditions.tempoInsane.value",
  "actor.system.conditions.unconscious.value",
  "actor.system.development.archetype",
  "actor.system.development.experiencePackage",
  "actor.system.development.occupation",
  "actor.system.development.personal",
  "actor.system.indefiniteInsanityLevel.max",
  "actor.system.indefiniteInsanityLevel.value",
  "actor.system.infos.age",
  "actor.system.infos.archetype",
  "actor.system.infos.birthplace",
  "actor.system.infos.occupation",
  "actor.system.infos.organization",
  "actor.system.infos.playername",
  "actor.system.infos.residence",
  "actor.system.infos.sex",
  "actor.system.infos.type",
  "actor.system.monetary.assets",
  "actor.system.monetary.assetsDetails",
  "actor.system.monetary.cash",
  "actor.system.monetary.spent",
  "actor.system.monetary.spendingLevel",
  "actor.system.special.attacksPerRound",
  "actor.system.special.attribs.move.primary.enabled",
  "actor.system.special.attribs.move.primary.type",
  "actor.system.special.attribs.move.primary.value",
  "actor.system.special.attribs.move.secondary.enabled",
  "actor.system.special.attribs.move.secondary.type",
  "actor.system.special.attribs.move.secondary.value",
  "actor.system.special.sanLoss.checkFailled",
  "actor.system.special.sanLoss.checkPassed",
  "item.name",
  "item.system.adjustments.archetype",
  "item.system.adjustments.experience",
  "item.system.adjustments.experiencePackage",
  "item.system.adjustments.occupation",
  "item.system.adjustments.personal",
  "item.system.ammo",
  "item.system.base",
  "item.system.quantity",
  "item.system.value",
  "item.system.weight",
  "token.disposition",
  "token.elevation",
  "token.name",
  "token.rotation",
  "token.sight.angle",
  "token.sight.attenuation",
  "token.sight.brightness",
  "token.sight.color",
  "token.sight.contrast",
  "token.sight.enabled",
  "token.sight.range",
  "token.sight.saturation",
  "token.sight.visionMode"
];

/* -------------------------------------------- */

export const DERIVED_PROPERTIES = [
  "item.system.value"
];
